import React, { useEffect } from "react";
import Banner from "../../components/banner/Banner";
import Features from "../../components/features/Features";
import Projects from "../../components/projects/Projects";
import Resume from "../../components/resume/Resume";
import Testimonial from "../../components/tesimonial/Testimonial";
import Contact from "../../components/contact/Contact";
import { useLocation , useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";

const HomePage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state && location.state.scrollTo) {
            scroller.scrollTo(location.state.scrollTo, {
                duration: 500,
                delay: 0,
                smooth: true,
                offset: -70,
            });

            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);

    return (
        <div className="w-full h-auto bg-bodyColor text-lightText">
            <section id="home">
                <Banner />
            </section>
            <section id="features">
                <Features />
            </section>
            <section id="projects">
                <Projects />
            </section>
            <section id="resume">
                <Resume />
            </section>
            <section id="testimonial">
                <Testimonial />
            </section>
            <section id="contact">
                <Contact />
            </section>
        </div>
    );
};

export default HomePage;
